import React, { useState, useContext, useEffect } from "react";
import { Box, Typography, Stack, Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import axios from "../../api/axios";

import GeneralContext from "../GeneralContext/GeneralContext";
import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import PageBgBlock from "../GeneralComponents/PageBgBlock";

const UUID = () => {
  const { pageTitle, setPageTitle } = useContext(GeneralContext);
  const [uuid, setUuid] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showRaw, setShowRaw] = useState(false);

  const handleSubmit = async (event) => {
    setError(false);
    setLoading(true);
    setResponseData(null);
    setShowRaw(false);
    event.preventDefault();

    if (!uuid) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.getUUID(uuid);
      setResponseData(response.data[0]);
    } catch (err) {
      setError(true);
      setResponseData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPageTitle("UUID");
  }, [setPageTitle]);

  const getColorConfig = (valid) => {
    if (valid === null) return { bg: "#F5F5F5", text: "#333" };
    return valid ? { bg: "#C8E6C9", text: "#1B5E20" } : { bg: "#FFCDD2", text: "#BE0A1F" };
  };

  const isPlazoValido = () => {
    if (!responseData?.timestamp || !responseData?.st_tstamp_mensaje) return null;
    const ts1 = new Date(responseData.st_tstamp_mensaje);
    const ts2 = new Date(responseData.timestamp);
    const diff = Math.abs(ts2 - ts1) / (1000 * 60); // diferencia en minutos
    return diff <= 30;
  };

  const plazoConfig = getColorConfig(responseData ? isPlazoValido() : null);
  const integridadConfig = getColorConfig(responseData ? !responseData.error : null);

  return (
    <PageBody>
      <PageBgBlock pad="3rem 6rem">
        <Typography variant="h1" align="center" sx={{ marginBottom: "1.2rem" }}>
          ESTADO DEL ENVÍO DE DATOS
        </Typography>

        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed" }}>
          <Box
            justifyContent="center"
            sx={{ maxWidth: "80%", margin: "0 auto", display: "flex" }}
          >
            <Typography
              variant="body"
              align="center"
              sx={{ marginBottom: "40px" }}
            >
              Introduzca el UUID tal como lo recibió desde el webservice. Aquí podrá obtener información detallada sobre su trazabilidad y los eventos que ocurrieron a lo largo de su proceso, <b> debe tener en cuenta que si los datos fueron enviados fuera de plazo y/o el proceso de datos fue inválido se harán descuentos en su prefactura.</b>
            </Typography>
          </Box>

          <form onSubmit={handleSubmit}>
            <FormControl
              sx={{ m: 1, minWidth: "100%", maxWidth: "100%", marginBottom: "39px" }}
            >
              <TextField
                required
                id="outlined-required"
                label="Ingresa UUID"
                size="small"
                value={uuid}
                onChange={(e) => setUuid(e.target.value)}
              />
            </FormControl>
            <PageButtonBlack loading={loading} width="312px">
              Obtener información
            </PageButtonBlack>
          </form>

          {!loading && (responseData || error) && (
            <>
              <Grid container spacing={2} alignItems="stretch" sx={{paddingTop: 4}}>
                <Grid size={6}>
                  <Box
                    sx={{
                      backgroundColor: plazoConfig.bg,
                      height: "100%",
                      p: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: 150,
                      borderRadius: 2,
                    }}
                  >
                    <Stack spacing={1} sx={{ textAlign: "center" }}>
                      <Typography variant="h5" sx={{ color: plazoConfig.text }}>
                        PLAZO DE DATOS: {!responseData ? "-" : isPlazoValido() ? "Dentro" : "Fuera"}
                      </Typography>
                      <Typography variant="small">
                        (Los datos válidos pueden tener máximo 30 minutos de retraso, contando que tienen 1 envío inválido de 15 minutos y un reintento 15 minutos)
                      </Typography>
                      <Typography variant="body" sx={{fontWeight: 500, paddingTop: 1}}>INGRESO DE LOS DATOS A SAGEC:</Typography>
                      <Typography variant="body">{!responseData ? "-" : responseData.st_tstamp_mensaje}</Typography>
                      <Typography variant="body" sx={{fontWeight: 500, paddingTop: 1}}>FECHA Y HORA DE ORIGEN DE LOS DATOS</Typography>
                      <Typography variant="body">{!responseData ? "-" : responseData.timestamp}</Typography>
                    </Stack>
                  </Box>
                </Grid>
                <Grid size={6}>
                  <Box
                    sx={{
                      backgroundColor: integridadConfig.bg,
                      height: "100%",
                      p: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: 150,
                      borderRadius: 2,
                    }}
                  >
                    <Stack spacing={1} sx={{ textAlign: "center" }}>
                      <Typography variant="h5" sx={{ color: integridadConfig.text }}>
                        CHEQUEO DE INTEGRIDAD: {!responseData ? "-" : responseData.error ? "Inválido" : "Válido"}
                      </Typography>
                      <Typography variant="small">
                        Verifica que los datos cumplan con el tipo esperado y valores dentro de rangos válidos, asegurando consistencia y cumplimiento de reglas de negocio.
                      </Typography>
                      <Typography variant="body" sx={{fontWeight: 500, paddingTop: 2 }}>MENSAJE:</Typography>
                      <Typography variant="small">
                        {!responseData ? "-" : responseData.error_message !== "" ? responseData.error_message : "Procesado sin errores"}
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
              </Grid>

              <Box sx={{ textAlign: "center", marginTop: 4 }}>
                <PageButtonWhite onClick={() => setShowRaw(!showRaw)} width="312px">
              {showRaw ? "Ocultar datos (raw)" : "Mostrar los datos (raw)"}
            </PageButtonWhite>
               <Box sx={{width: "300px", paddingTop: 2, paddingBottom: 3, margin: "auto"}}>
              <Typography variant="small" >
                       Es posible mostrar los datos del informe en un formato raw para más detalles en un formato más técnico.
                      </Typography>
              </Box>
              </Box>
            </>
          )}

          {showRaw && responseData && (
            <Box style={{ marginTop: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  padding: "10px 20px",
                  backgroundColor: "#E4E4E4",
                  borderRadius: "10px",
                  fontSize: "12px",
                }}
              >
                <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                  {JSON.stringify(responseData, null, 2)}
                </pre>
              </Paper>
            </Box>
          )}

          {error && !responseData && (
            <Box style={{ marginTop: "39px" }}>
              <Alert variant="outlined" severity="error">
                <Box
                  justifyContent="center"
                  sx={{ maxWidth: "100%", margin: "0 auto", display: "flex" }}
                >
                  <Typography variant="body" align="left">
                    UUID no encontrado.
                  </Typography>
                </Box>
              </Alert>
            </Box>
          )}
        </Box>
      </PageBgBlock>
    </PageBody>
  );
};

export default UUID;
